import React from 'react';
import styled, { css } from 'styled-components';
import Icon from '~/components/atom/Icon';
import { IMAGE_CARD_SIZE } from '~/components/atom/ImageCard';
import JustificationContainer from '~/components/atom/JustificationContainer';
import { Body, Variant } from '~/components/atom/Typography';
import { Link } from '~/components/molecule/Link';

const text = {
  selectedAssetMissing: 'De geselecteerde asset is niet gevonden.',
  goToBranding: 'Ga naar Huisstijl',
  addAsset: 'om een nieuwe toe te voegen of selecteer een andere asset.',
};

export type Props = {
  dataTestId?: string;
  className?: string;
};

const MissingAssetPlaceholder: React.FCC<Props> = ({}) => (
  <Container direction="column" gap="xxs" align="center">
    <Icon name="alert-circle" size="m" color={{ group: 'danger' }} />
    <Body
      size="s"
      variant={Variant.secondary}
      color={{ group: 'danger' }}
      margin={[null]}
      align="center"
    >
      {text.selectedAssetMissing}{' '}
      <ErrorLink to={`/-/settings/brand`}>{text.goToBranding}</ErrorLink>{' '}
      {text.addAsset}
    </Body>
  </Container>
);

const Container = styled(JustificationContainer)(
  ({ theme }) => css`
    color: ${theme.color('danger')};
    border: 1px dashed ${theme.color('danger')};
    border-radius: ${theme.getTokens().border.radius.base};
    padding: ${theme.space('s')};
    width: ${IMAGE_CARD_SIZE}px;
    height: ${IMAGE_CARD_SIZE}px;
    background-color: ${theme.color('danger', 'translucent')};
  `,
);

const ErrorLink = styled(Link)(
  ({ theme }) => css`
    color: ${theme.color('danger', 'base')};
    font-weight: ${theme.fontWeight('semiBold')};
  `,
);

export default MissingAssetPlaceholder;
